import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import DailyCloseModel from "../../../Components/DailyCloseModel";

const ScanPage = () => {
  const location = useLocation();

  const [payload, setPayload] = useState(null);
  const [mobileInput, setMobileInput] = useState("");
  const [error, setError] = useState("");
  const [showVerifyModal, setShowVerifyModal] = useState(false);
  const [showDailyCloseModal, setShowDailyCloseModal] = useState(false);

  // 🔐 Decode QR
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const encoded = params.get("data");

    if (!encoded) return;

    try {
      const decoded = JSON.parse(atob(encoded));

      if (!decoded?.ShopDetailID || !decoded?.mobile) {
        throw new Error("Invalid QR");
      }

      setPayload(decoded);
      setShowVerifyModal(true);
    } catch (err) {
      setError("Invalid or corrupted QR code.");
    }
  }, [location]);

  // ✅ Verify Mobile
  const handleVerify = (e) => {
    e.preventDefault();

    if (!payload) return;

    if (mobileInput.trim() === payload.mobile.toString()) {
      setError("");
      setShowVerifyModal(false);
      setShowDailyCloseModal(true);
    } else {
      setError("The mobile number entered is not registered.");
    }
  };

  if (!payload && !showVerifyModal) {
    return (
      <div className="h-screen flex items-center justify-center">
        <p className="text-gray-500">Invalid QR Code</p>
      </div>
    );
  }

  return (
    <>
      {/* 🔐 Verify Modal */}
      {showVerifyModal && (
        <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50">
          <div className="bg-white w-full max-w-md p-6 rounded-xl shadow-xl">
            <h2 className="text-lg font-bold mb-2">Verify Mobile Number</h2>

            <p className="text-sm text-gray-600 mb-4">Enter your registered mobile number to continue.</p>

            <form onSubmit={handleVerify}>
              <input
                type="tel"
                value={mobileInput}
                onChange={(e) => setMobileInput(e.target.value)}
                placeholder="Enter Mobile Number"
                className="w-full border px-3 py-2 rounded-lg mb-3"
                required
              />

              {error && <p className="text-red-600 text-sm mb-2">{error}</p>}

              <button type="submit" className="w-full bg-blue-600 text-white py-2 rounded-lg">
                Verify
              </button>
            </form>
          </div>
        </div>
      )}

      {showDailyCloseModal && (
        <DailyCloseModel
          isOpen={true}
          onClose={() => setShowDailyCloseModal(false)}
          selectedShop={{
            ShopDetailID: payload.ShopDetailID,
            ShopName: payload.ShopName,
          }}
        />
      )}
    </>
  );
};

export default ScanPage;
